module.exports = __webpack_public_path__ + "img/badge50.08cb73f6.png";